module.exports = __webpack_public_path__ + "static/studio-tropik-5e4418454b9d0c0609665b983131bb2d.png";